






import { defineComponent } from '@vue/composition-api'
import CardStage from '@/components/CardStage.vue'

export default defineComponent({
  components: {
    CardStage
  },
  props: {},
  setup () {
    return {}
  }
})
